import { Button, Flex, Modal } from "antd";
import { CheckSquareOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useCalendarIssues } from "components/CalendarIssues/context";
import convertDate from "helpers/convertDate";

const CustomEditorContent = ({
  calendar_issue,
  confirmMoveIssue,
  handleEdit,
  close,
  date,
}) => {
  if (calendar_issue?.id) {
    return (
      <>
        <p style={{ margin: 0, textAlign: "center" }}>
          Czy na pewno chcesz{" "}
          {calendar_issue?.service_date ? "zmienić" : "dodać"} datę umówienia
          dla zgłoszenia <br />
          <strong>{calendar_issue?.identifier}</strong> <br />
          {calendar_issue?.service_date && (
            <>
              {"z "}
              <strong>{convertDate(calendar_issue?.service_date)}</strong>
            </>
          )}
          na <strong>{convertDate(date)}</strong>?
        </p>
        <Flex
          gap={20}
          style={{ margin: "20px auto 0", width: "100%", maxWidth: 300 }}
        >
          <Button danger block type="primary" htmlType="button" onClick={close}>
            Nie
          </Button>
          <Button
            block
            type="primary"
            htmlType="button"
            onClick={() => {
              close();
              confirmMoveIssue(date);
            }}
          >
            Tak
          </Button>
        </Flex>
      </>
    );
  }
  return (
    <Flex
      gap={20}
      style={{ margin: "30px auto 10px", width: "100%", maxWidth: 300 }}
    >
      <Button
        block
        type="primary"
        htmlType="button"
        onClick={() => handleEdit("new_issue")}
        icon={<CheckSquareOutlined />}
      >
        Zgłoszenie
      </Button>
      <Button
        block
        type="primary"
        htmlType="button"
        onClick={() => handleEdit("new_task")}
        icon={<UnorderedListOutlined />}

      >
        Priorytet
      </Button>
    </Flex>
  );
};

const CustomEditor = ({ handleEdit, close, date }) => {
  const { calendar_issue, confirmMoveIssue } = useCalendarIssues();

  return (
    <Modal
      open
      onCancel={close}
      footer={null}
      title={calendar_issue?.id ? "Potwierdzenie" : "Wybierz typ nowej pozycji"}
    >
      <CustomEditorContent
        calendar_issue={calendar_issue}
        confirmMoveIssue={confirmMoveIssue}
        handleEdit={handleEdit}
        close={close}
        date={date}
      />
    </Modal>
  );
};

export default CustomEditor;
